import "../../chunk-D57E6H3M.mjs";

// src/i18n/locales/en.json
var supportRequest = {
  confirmationTitle: "Review your support request",
  submittingTitle: "Sending your support request",
  createdTitle: "Support request sent",
  failedTitle: "Support request was not sent",
  unknownTitle: "Checking your support request",
  contact: "Contact",
  submittingDescription: "We\u2019re confirming your request automatically.",
  createdDescription: "You\u2019ll hear from the {{storeName}} support team soon.",
  createdDescriptionFallback: "You\u2019ll hear from the store\u2019s support team soon.",
  failedDescription: "The request was rejected before it was sent. Retry this request when the connection is available.",
  retryAfter: "You can retry after {{time}}.",
  unknownDescription: "We\u2019re checking whether your request was sent. You don\u2019t need to send it again.",
  confirmationFollowUp: "Sends these details and the current conversation. Follow-up happens outside this chat.",
  followUp: "Follow-up happens outside this chat. Replies and later chat messages are not included in this request.",
  send: "Submit",
  retry: "Retry support request"
};
var thinking = {
  toggle: "Reasoning",
  placeholder: "Thinking\u2026"
};
var chatPanel = {
  width: "Chat width",
  height: "Chat height"
};
var appBar = {
  storeAssistant: "AI Store Agent",
  close: "Close",
  repliesWithin24h: "Typically replies within 24 hours"
};
var poweredBy = {
  alt: "Powered by BuyScout"
};
var chatBar = {
  openChatAria: "Open chat",
  unreadAria: "New message",
  placeholder: "Ask me anything\u2026",
  mentionProductsTitle: "Mention Products",
  mentionProductAria: "Mention product",
  useVoiceTitle: "Use Voice",
  switchToVoiceAria: "Switch to voice input",
  sendMessageAria: "Send message",
  sendTitle: "Send message",
  endVoiceTitle: "End Voice",
  muteAria: "Mute microphone",
  muteTitle: "Mute",
  switchToTextAria: "Switch to text input",
  stopTitle: "Stop",
  stopAria: "Stop the reply",
  voiceUnavailable: {
    "team-takeover": "Voice chat isn\u2019t available while a member of our team is handling this chat."
  },
  errorProductLimit: "You can @ mention at most {{max}} different products",
  errorProductNotFound: "Some mentioned products are unavailable. Remove them to send.",
  errorMessageTooLong: "Message cannot exceed {{max}} characters"
};
var voiceStage = {
  allowMic: "Allow microphone access",
  connecting: "Connecting\u2026",
  toolCalling: "One moment\u2026",
  permissionHint: "Check for the browser permission prompt",
  turn: {
    ready: "Ready \u2014 start talking",
    listening: "Listening\u2026",
    thinking: "Thinking\u2026",
    speaking: "Speaking\u2026"
  },
  error: {
    "mic-blocked": "Microphone access is blocked. Allow it in your browser\u2019s site settings, then try again.",
    "mic-missing": "No microphone found. Connect one, then try again.",
    "mic-busy": "Another app is using your microphone. Close it, then try again.",
    connection: "The voice connection dropped. Check your internet connection, then try again.",
    service: "Voice chat isn\u2019t available right now. Try again in a moment."
  }
};
var popupMessage = {
  dismissAria: "Dismiss",
  newMessage: "New message: {{message}}"
};
var chatLog = {
  event: {
    cartAdd: "You just added <0></0> to your cart.",
    cartRemove: "You just removed <0></0> from your cart.",
    productVisit: "You're viewing <0></0>."
  },
  jumpToLatest: "Scroll to latest message",
  showEarlier: "Show earlier messages"
};
var chatImage = {
  viewLargerAria: "View image larger",
  viewLargerAriaNamed: "View {{name}} larger",
  previewTitle: "Image preview",
  closeAria: "Close preview"
};
var chatMessage = {
  copyAria: "Copy message",
  goodResponseTitle: "Good response",
  likeAria: "Like",
  badResponseTitle: "Bad response",
  dislikeAria: "Dislike",
  actionsAria: "Message actions",
  imageUnavailable: "Image unavailable",
  replyFailed: "Couldn\u2019t get a reply",
  replyFailedDetailsAria: "Error details",
  usageLimitReached: "This store has reached its plan\u2019s usage quota.",
  dislikeReasonTitle: "What went wrong?",
  dislikeReasons: {
    incorrect_info: "Wrong info",
    not_helpful: "Not helpful",
    other: "Other"
  },
  dislikeReasonThanks: "Thanks for your feedback"
};
var productMention = {
  searchAria: "Search products",
  listAria: "Product results",
  searchPlaceholder: "Search products\u2026",
  removeAria: "Remove product mention",
  currentProductChip: "Current product",
  empty: "No products found"
};
var clarifyingQuestions = {
  prevQuestion: "Previous question",
  loadingNext: "Loading next question",
  loadingQuestions: "Loading questions\u2026",
  nextQuestion: "Next question",
  otherOption: "Other",
  answerPlaceholder: "Type your answer\u2026",
  otherAnswerAria: "Other answer",
  heading: "Questions",
  navOf: "of",
  otherLabel: "Other\u2026",
  skip: "Skip",
  submit: "Submit",
  continue: "Continue",
  skipped: "Skipped",
  options: "Options",
  userAnswer: "User Answer",
  sent: "Answers sent"
};
var inlineForm = {
  heading: "Details",
  submit: "Submit",
  skip: "Skip",
  skipped: "Skipped",
  notSubmitted: "Not submitted",
  errorRequired: "This field is required",
  errorEmail: "Enter a valid email address",
  errorPhone: "Enter a valid phone number",
  errorNumber: "Enter a valid number",
  sent: "Details sent",
  sendFailed: "Couldn\u2019t send your details. Try again."
};
var product = {
  addToCart: "Add to Cart",
  added: "Added!",
  failed: "Failed",
  addToCartAria: "Add {{title}} to cart",
  addedAria: "{{title}} added to cart",
  failedAria: "Couldn't add {{title}} to cart",
  listLabel_one: "{{count}} product",
  listLabel_other: "{{count}} products",
  scrollPrevious: "Previous products",
  scrollNext: "Next products"
};
var orderStatus = {
  heading: "Order {{number}}",
  placedOn: "Placed {{date}}",
  listLabel_one: "{{count}} order",
  listLabel_other: "{{count}} orders",
  shipmentOf: "Shipment {{index}} of {{count}}",
  progressLabel: "Shipment progress",
  deliveredOn: "Delivered {{date}}",
  expectedOn: "Expected {{date}}",
  track: "Track shipment",
  trackAria: "Track {{carrier}} shipment {{number}} (opens in new tab)",
  trackAriaNoCarrier: "Track shipment {{number}} (opens in new tab)",
  trackAriaBare: "Track shipment (opens in new tab)",
  status: {
    processing: "Processing",
    onHold: "On hold",
    partiallyShipped: "Partially shipped",
    shipped: "Shipped",
    cancelled: "Cancelled",
    restocked: "Restocked",
    noShippingNeeded: "No shipping needed",
    unknown: "Status unavailable"
  },
  shipment: {
    confirmed: "Confirmed",
    labelCreated: "Label created",
    inTransit: "In transit",
    outForDelivery: "Out for delivery",
    attemptedDelivery: "Delivery attempted",
    delayed: "Delayed",
    delivered: "Delivered",
    readyForPickup: "Ready for pickup",
    pickedUp: "Picked up",
    notDelivered: "Not delivered",
    failed: "Delivery failed",
    fulfilled: "Shipped",
    cancelled: "Cancelled",
    unknown: "Status unavailable"
  },
  step: {
    confirmed: "Confirmed",
    shipped: "Shipped",
    outForDelivery: "Out for delivery",
    delivered: "Delivered",
    readyForPickup: "Ready for pickup",
    pickedUp: "Picked up"
  }
};
var tryOn = {
  uploadInputAria: "Upload a photo",
  button: "Try on",
  back: "Back",
  uploadTitle: "Add a full-body photo",
  uploadRetryTitle: "Try another photo",
  uploadHint: "Facing the camera \xB7 good light \xB7 fitted clothing",
  uploadRefused: "That file isn\u2019t a photo. Choose an image, such as a JPG or PNG.",
  savedPhotoTitle: "Use your saved photo",
  savedPhotoHint: "Instant preview \u2014 no new upload",
  sampleDivider: "or pick a sample",
  sampleAria: "Use sample: {{name}}",
  privacyNote: "Private \xB7 deleted right after the preview",
  processing: "Styling your preview\u2026",
  badge: "Virtual try-on",
  enlargeHint: "Tap to enlarge",
  change: "Change",
  done: "Done",
  addToCartPlain: "Add to Cart"
};
var loadingState = {
  loading: "Loading\u2026"
};
var spinner = {
  loading: "Loading"
};
var copyButton = {
  copy: "Copy",
  copied: "Copied",
  failed: "Could not copy",
  copyValue: "Copy {{value}}"
};
var link = {
  opensInNewTab: "(opens in new tab)"
};
var toast = {
  region: "Notifications",
  dismiss: "Dismiss",
  viewportLabel: "Notifications ({{hotkey}})"
};
var markdownEditor = {
  placeholder: "Start typing\u2026",
  uploading: "Uploading image\u2026",
  imageDialog: {
    insertTitle: "Insert Image",
    editTitle: "Edit Image",
    description: "Choose an image for your document.",
    close: "Close image dialog",
    source: "Image source",
    upload: "Upload",
    url: "Image URL",
    choose: "Choose Image",
    drag: "or drag an image here",
    replace: "Replace Image",
    preview: "Preview",
    previewAlt: "Selected image preview",
    alt: "Alternative Text",
    optional: "Optional",
    altPlaceholder: "Describe what the image shows",
    altHelp: "A short description for people who can\u2019t see the image.",
    addTitle: "Add an Image Title",
    imageTitle: "Image Title",
    titlePlaceholder: "Shown when hovering over the image",
    invalidFile: "Choose an image file.",
    unsupportedType: "This file type is not supported. Use {{formats}}.",
    tooLarge: "Choose an image of {{limit}} or less.",
    invalidUrl: "Enter a valid image URL.",
    loadFailed: "This image could not be loaded. Choose another image or try again.",
    uploadFailed: "The image could not be uploaded. Try again.",
    save: "Save Image"
  }
};
var textField = {
  showPassword: "Show password"
};
var combobox = {
  count: "{{current}} of {{max}}"
};
var slider = {
  minimum: "Minimum",
  maximum: "Maximum"
};
var numberField = {
  between: "Between {{min}} and {{max}}",
  atLeast: "{{min}} or more",
  atMost: "Up to {{max}}",
  tooLow: "Enter {{min}} or more",
  tooHigh: "Enter {{max}} or less"
};
var valueList = {
  before: "Before",
  after: "After"
};
var googleButton = {
  signIn: "Sign in with Google"
};
var announcementBar = {
  view: "View",
  ok: "OK",
  dismissAria: "Dismiss announcement"
};
var chatInput = {
  placeholder: "Type a message\u2026",
  productNotFound: "Product Not Found"
};
var tool = {
  getDiscounts: {
    label: "Get Discounts",
    success: "Found available discounts"
  },
  searchStoreProducts: {
    label: "Search Store Products",
    success: "Found matching products"
  },
  getRelatedProducts: {
    label: "Get Related Products",
    success: "Found related products"
  },
  getComplementaryProducts: {
    label: "Get Complementary Products",
    success: "Found complementary products"
  },
  getStorePolicies: {
    label: "Get Store Policies",
    success: "Retrieved store policies"
  },
  getCustomerOrders: {
    label: "Look Up Orders",
    success: "Retrieved your order history"
  },
  searchKnowledge: {
    label: "Search Store Info",
    success: "Looked up store information"
  },
  getCurrentDate: {
    label: "Get Current Date",
    success: "Checked current date"
  },
  requestCustomerSupport: {
    label: "Contact Customer Support",
    success: "Customer support has been notified"
  },
  fallback: {
    failed: "Action failed",
    interrupted: "Stopped before finishing",
    succeeded: "Done"
  }
};
var mdxEditor = {
  toolbar: {
    undo: "Undo {{shortcut}}",
    redo: "Redo {{shortcut}}",
    bold: "Bold",
    italic: "Italic",
    underline: "Underline",
    removeBold: "Remove bold",
    removeItalic: "Remove italic",
    removeUnderline: "Remove underline",
    link: "Create link",
    image: "Insert image",
    bulletedList: "Bulleted list",
    numberedList: "Numbered list",
    checkList: "Check list",
    table: "Insert Table",
    thematicBreak: "Insert thematic break",
    toggleGroup: "toggle group",
    blockTypeSelect: {
      placeholder: "Block type",
      selectBlockTypeTooltip: "Select block type"
    },
    blockTypes: {
      heading: "Heading {{level}}",
      paragraph: "Paragraph",
      quote: "Quote"
    }
  },
  createLink: {
    cancelTooltip: "Cancel change",
    saveTooltip: "Set URL",
    text: "Anchor text",
    textTooltip: "The text to be displayed for the link",
    title: "Link title",
    titleTooltip: "The link title",
    url: "URL",
    urlPlaceholder: "Select or paste an URL"
  },
  linkPreview: {
    copied: "Copied!",
    copyToClipboard: "Copy to clipboard",
    edit: "Edit link URL",
    open: "Open {{url}} in new window",
    remove: "Remove link"
  },
  uploadImage: {
    addViaUrlInstructions: "Or add an image from an URL:",
    addViaUrlInstructionsNoUpload: "Add an image from an URL:",
    alt: "Alt:",
    autoCompletePlaceholder: "Select or paste an image src",
    dialogTitle: "Upload an image",
    height: "Height:",
    title: "Title:",
    uploadInstructions: "Upload an image from your device:",
    width: "Width:"
  },
  imageEditor: {
    deleteImage: "Delete image",
    editImage: "Edit image"
  },
  table: {
    alignCenter: "Align center",
    alignLeft: "Align left",
    alignRight: "Align right",
    columnMenu: "Column menu",
    deleteColumn: "Delete this column",
    deleteRow: "Delete this row",
    deleteTable: "Delete table",
    insertColumnLeft: "Insert a column to the left of this one",
    insertColumnRight: "Insert a column to the right of this one",
    insertRowAbove: "Insert a row above this one",
    insertRowBelow: "Insert a row below this one",
    rowMenu: "Row menu",
    textAlignment: "Text alignment"
  },
  dialogControls: {
    cancel: "Cancel",
    save: "Save"
  },
  contentArea: {
    editableMarkdown: "editable markdown"
  }
};
var merchantAgentChat = {
  transcript: "Conversation",
  empty: "Ask about your store, or ask for a change. Changes you can undo are made right away; anything else waits for your confirmation.",
  composer: {
    label: "Message",
    waitingForDecision: "Confirm or decline the proposed change to continue."
  },
  action: {
    pending: "Needs confirmation",
    confirmed: "Confirmed",
    declined: "Declined",
    expired: "Expired",
    value: "Value",
    localeDefault: "Default",
    unchanged: "{{items}}: unchanged",
    showUnchanged: "Show more",
    hideUnchanged: "Show less",
    confirm: "Confirm",
    decline: "Decline"
  },
  change: {
    applied: "Applied",
    undone: "Undone",
    undo: "Undo",
    undoneNote: "It\u2019s back to how it was before this change.",
    noUndo: "This change can\u2019t be undone.",
    refusal: {
      changedSince: "This changed again since, so it can\u2019t be undone. Ask your AI employee to change it back.",
      alreadyUndone: "This change was already undone.",
      notUndoable: "This change can\u2019t be undone. Ask your AI employee to change it back.",
      notFound: "This change no longer exists.",
      failed: "The change couldn\u2019t be undone. Try again in a minute."
    }
  },
  notice: {
    off: "Your AI employee is turned off for this store.",
    cap: "Your AI employee has used up this month\u2019s quota. It resets on {{date}}.",
    capNoDate: "Your AI employee has used up this month\u2019s quota.",
    busy: "Your AI employee is still working in this conversation, so it was reloaded.",
    decided: "This change was already confirmed or declined, so the conversation was reloaded.",
    expired: "This change expired before it was decided and wasn\u2019t made. The conversation was reloaded.",
    notFound: "This conversation or change no longer exists.",
    running: "Your AI employee is still answering in this conversation. Reload in a moment to see the reply.",
    failed: "Something went wrong. Try again in a minute.",
    loadFailed: "Your conversation couldn\u2019t be loaded. Reload to try again.",
    reload: "Reload"
  }
};
var shared = {
  chat: {
    search: "Search conversations",
    list_label: "Conversations",
    empty_state: "No conversations found.",
    empty_filtered: "Nothing matches your filters.",
    clear_filters: "Clear filters",
    retry: "Try again",
    retry_hint: "Please try again in a moment.",
    retrying: "Trying again\u2026",
    empty_prompt: "Select a conversation to view its messages.",
    back_to_inbox: "Back to inbox",
    anonymous_visitor: "Anonymous visitor",
    anonymous_user: "Anonymous user",
    opted_out: "Opted out",
    pagination: {
      label: "Conversation pages",
      previous: "Previous page",
      next: "Next page",
      page: "Page {{page}}",
      summary: "{{shown}} of {{total}}"
    },
    filter: {
      channel: "Conversation channel",
      all: "All channels",
      engaged: "Engaged"
    },
    channel: {
      website: "Website",
      email: "Email",
      sms: "SMS"
    },
    content: {
      recent_messages_only: "Only the most recent messages are retained.",
      session_count_one: "{{count}} session",
      session_count_other: "{{count}} sessions",
      thread_count_one: "{{count}} thread",
      thread_count_other: "{{count}} threads",
      message_count_one: "{{count}} message",
      message_count_other: "{{count}} messages",
      last_active: "Last active {{date}}",
      session_number: "Session #{{number}}",
      thread_number: "Thread #{{number}}",
      session_started: "Started: {{date}}",
      customer_email: "Email: {{email}}",
      customer_id: "Customer ID: {{id}}",
      delete_session: "Delete session",
      delete: "Delete"
    },
    token_usage: {
      input: "Input: {{value}}",
      cached: "Cached: {{value}}",
      output: "Output: {{value}}",
      reasoning: "Reasoning: {{value}}",
      total: "Total: {{value}}",
      tokens_one: "{{value}} token",
      tokens_other: "{{value}} tokens"
    },
    log: {
      feedback: {
        like: "Like",
        dislike: "Dislike",
        dislike_reason: "Dislike \xB7 {{reason}}"
      },
      suggested_replies: "Suggested replies",
      page_visited_label: "Page visited:",
      viewing_product_label: "Viewing product:",
      empty_state: "No messages in this chat session yet.",
      sent_by_you: "You",
      sent_by_system: "Automatic message",
      attachment: {
        image_alt: "Attached image",
        open: "Open attachment",
        unavailable: "Attachment not received",
        reason: {
          not_entitled: "Your plan does not include attachments on this channel.",
          store_switched_off: "The store was switched off when this arrived, so the attachment was not received.",
          not_ingested: "This channel cannot store attachments yet.",
          no_credentials: "Reconnect this channel to receive attachments.",
          unaddressable: "The sender provided no usable attachment.",
          refused: "The file was hosted somewhere we do not fetch from.",
          unsupported: "This file type cannot be stored.",
          too_large: "This attachment was over the size or count limit for one message.",
          failed: "The attachment could not be stored. Ask the customer to resend it.",
          unknown: "The attachment could not be stored."
        }
      }
    },
    reply: {
      heading: "Reply",
      to: "To {{recipient}}",
      placeholder: "Reply to the customer\u2026",
      send: "Send",
      sending: "Sending\u2026",
      send_hint: "Send reply (\u2318/Ctrl+Enter)",
      sent: "Reply sent.",
      ai_paused: "AI is paused \u2014 you have taken over this conversation",
      opted_out: "This customer texted STOP and has opted out of SMS from this store. You can't message them until they text START.",
      return_to_ai: "Return to AI",
      attach: "Attach image",
      attach_files: "Attach files",
      expand: "Expand composer",
      collapse: "Collapse composer",
      resize: "Resize composer",
      resize_hint: "Drag up to expand, down to shrink. Click to toggle size.",
      resize_value: "{{percent}}% of the maximum height",
      pending_attachments: "Attachments to send",
      attachment: "Attachment",
      remove_attachment: "Remove attachment",
      remove_named_attachment: "Remove {{name}}",
      uploading_files_one: "Uploading {{count}} file\u2026",
      uploading_files_other: "Uploading {{count}} files\u2026",
      attachment_error: {
        unsupported_type: "Only JPEG, PNG or GIF images can be sent.",
        unsupported_file_type: "This file type is not supported for this conversation.",
        too_many: "A message can carry at most {{count}} attachments.",
        too_large: "Attachments in one message must total {{limit}} or less."
      }
    },
    email: {
      untitled: "Email conversation",
      addresses: "Message addresses",
      to_address: "To {{address}}",
      details: "Details",
      from: "From",
      to: "To",
      copy_from: "Copy from address: {{address}}",
      copy_to: "Copy to address: {{address}}",
      show_html: "Show HTML",
      show_plain_text: "Show plain text",
      html_title: "Email from {{sender}}",
      quoted_history: "Quoted history",
      subject: "Subject",
      reply_to: "Reply-To",
      cc: "Cc",
      copy_reply_to: "Copy reply-to address: {{address}}",
      copy_cc: "Copy Cc address: {{address}}",
      html_too_large: "The formatted version of this email was too large to keep, so only its text is shown."
    }
  }
};
var timestamp = {
  dayAtTime: "{{day}} at {{time}}"
};
var en_default = {
  supportRequest,
  thinking,
  chatPanel,
  appBar,
  poweredBy,
  chatBar,
  voiceStage,
  popupMessage,
  chatLog,
  chatImage,
  chatMessage,
  productMention,
  clarifyingQuestions,
  inlineForm,
  product,
  orderStatus,
  tryOn,
  loadingState,
  spinner,
  copyButton,
  link,
  toast,
  markdownEditor,
  textField,
  combobox,
  slider,
  numberField,
  valueList,
  googleButton,
  announcementBar,
  chatInput,
  tool,
  mdxEditor,
  merchantAgentChat,
  shared,
  timestamp
};
export {
  announcementBar,
  appBar,
  chatBar,
  chatImage,
  chatInput,
  chatLog,
  chatMessage,
  chatPanel,
  clarifyingQuestions,
  combobox,
  copyButton,
  en_default as default,
  googleButton,
  inlineForm,
  link,
  loadingState,
  markdownEditor,
  mdxEditor,
  merchantAgentChat,
  numberField,
  orderStatus,
  popupMessage,
  poweredBy,
  product,
  productMention,
  shared,
  slider,
  spinner,
  supportRequest,
  textField,
  thinking,
  timestamp,
  toast,
  tool,
  tryOn,
  valueList,
  voiceStage
};
//# sourceMappingURL=en.mjs.map